@if (
  {
    allRoles: allRoles$ | async
  };
  as state
) {
  <roles-header (searchValueChange)="searchValue$.next($event)" [allRoles]="state.allRoles" />
  <roles-table [searchValue$]="searchValue$" [allRoles]="state.allRoles" />
} @else {
  <div class="oph-loading-container">
    <oph-loading />
  </div>
}
